export default function NoRebalanceIcon() {
    return (<svg width="61" height="81" viewBox="0 0 61 81" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 12C0 5.37258 5.37258 0 12 0H49C55.6274 0 61 5.37258 61 12V69C61 75.6274 55.6274 81 49 81H12C5.37258 81 0 75.6274 0 69V12Z" fill="url(#paint0_linear_44029_23167)" />
        <circle cx="30.5" cy="40.5" r="16.5" fill="#CC5C2D" />
        <path d="M24 41.3036L27.528 45.2812L37.4062 36" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <defs>
            <linearGradient id="paint0_linear_44029_23167" x1="8" y1="6.16038e-07" x2="52.5" y2="81" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FFF7EF" />
                <stop offset="1" stop-color="#FEF2E7" />
            </linearGradient>
        </defs>
    </svg>

    )
}